(function(){
  'use strict';
  var TH = window.TH || {}; var para = TH.para || function(k){ return ((k||0)/100).toFixed(2) + ' TL'; };
  function $(s,r){ return (r||document).querySelector(s); }
  function $$(s,r){ return [].slice.call((r||document).querySelectorAll(s)); }
  function bicim(sablon, v){ return sablon.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_,k){ return v[k] != null ? v[k] : ''; }); }

  // ---- Başlık altı puan özeti (yorum bölümündeki gerçek veriden) ----
  var oz = $('[data-puan-ozet]'), yp = $('#yorumlar .ty__puan'), ys = $('#yorumlar .ty__say'), yd = $('#yorumlar .ty__dolu');
  if (oz && yp) {
    $('[data-puan-ort]', oz).textContent = yp.textContent.trim();
    $('[data-puan-say]', oz).textContent = ys ? '(' + ys.textContent.trim() + ')' : '';
    if (yd) $('[data-puan-dolu]', oz).style.width = yd.style.width;
    oz.hidden = false;
  }

  // ---- Teslimat tahmini (iş günü, hafta sonu hariç) ----
  var ts = $('[data-teslim]');
  if (ts) {
    var isGunu = function(n){ var d = new Date(); var c = 0; while (c < n) { d.setDate(d.getDate()+1); var g = d.getDay(); if (g !== 0 && g !== 6) c++; } return d; };
    var loc = {tr:'tr-TR',de:'de-DE',fr:'fr-FR',ar:'ar',en:'en-GB'}[TH.locale] || 'en-GB';
    var f = function(d){ return d.toLocaleDateString(loc, {day:'numeric', month:'long'}); };
    var a = isGunu(+ts.dataset.min || 2), b = isGunu(+ts.dataset.max || 5);
    $('[data-teslim-yazi]', ts).innerHTML = ts.dataset.metin.replace('[tarih]', '<b>' + f(a) + ' – ' + f(b) + '</b>');
  }

  // ---- Sepet çekmecesi ----
  var cek = $('[data-cekmece]');
  if (cek) {
    var liste = $('[data-cek-liste]', cek), tesvik = $('[data-cek-tesvik]', cek), sonVaryant = null;
    var ac = function(){ cek.hidden = false; requestAnimationFrame(function(){ cek.classList.add('acik'); }); document.documentElement.classList.add('kilit'); yenile(); };
    var kapat = function(){ cek.classList.remove('acik'); document.documentElement.classList.remove('kilit'); setTimeout(function(){ cek.hidden = true; }, 280); };
    var api = function(url, veri){ return fetch(url, {method: veri ? 'POST' : 'GET', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: veri ? JSON.stringify(veri) : undefined}).then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); }); };
    var sayac = function(n){ $$('.sepet-ik b').forEach(function(b){ b.remove(); }); if (n > 0) $$('.sepet-ik').forEach(function(a){ var b = document.createElement('b'); b.textContent = n; a.appendChild(b); }); };
    var ciz = function(c){
      sayac(c.item_count);
      $('[data-cek-adet]', cek).textContent = c.item_count ? '(' + c.item_count + ')' : '';
      $('[data-cek-bos]', cek).hidden = c.item_count > 0;
      $('.cek__alt', cek).hidden = c.item_count === 0;
      liste.innerHTML = c.items.map(function(it, i){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
        var ind = it.original_line_price > it.final_line_price ? '<s>' + para(it.original_line_price) + '</s>' : '';
        var not = it.properties && it.properties['Hediye notu'] ? '<small class="cek__not">“' + it.properties['Hediye notu'].replace(/</g,'&lt;') + '”</small>' : '';
        return '<li class="cek__k" data-sat="' + (i+1) + '">' + (img ? '<img src="' + img + '" alt="" width="72" height="72">' : '<span></span>') +
          '<div class="cek__k-b"><b>' + it.product_title + '</b>' + (it.variant_title ? '<small>' + it.variant_title + '</small>' : '') + not +
          '<div class="cek__adet"><button type="button" data-cek-az aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-cek-cok aria-label="+">+</button></div></div>' +
          '<div class="cek__k-f">' + ind + '<b>' + para(it.final_line_price) + '</b><button type="button" class="cek__sil" data-cek-sil>' + (TH.t.kaldir || '×') + '</button></div></li>';
      }).join('');
      var ind = c.total_discount || 0;
      $('[data-cek-ind-satir]', cek).hidden = !ind;
      $('[data-cek-ind]', cek).textContent = '−' + para(ind);
      $('[data-cek-top]', cek).textContent = para(c.total_price);
      // Paket teşviki
      if (tesvik) {
        var ana = tesvik.dataset.ana, n = 0; sonVaryant = null;
        c.items.forEach(function(it){ if (it.handle === ana) { n += it.quantity; sonVaryant = it.variant_id; } });
        var p2 = +tesvik.dataset.p2, p3 = +tesvik.dataset.p3, yazi = '';
        if (n === 1) yazi = bicim(tesvik.dataset.m2, {fiyat: para(p2)});
        else if (n === 2) yazi = bicim(tesvik.dataset.m3, {fiyat: para(p3)});
        else if (n >= 3) yazi = tesvik.dataset.ok;
        tesvik.hidden = n === 0;
        $('[data-cek-tesvik-yazi]', tesvik).textContent = yazi;
        $('[data-cek-bir-daha]', tesvik).hidden = !(n === 1 || n === 2);
        $$('[data-adim]', tesvik).forEach(function(i){ i.classList.toggle('on', +i.dataset.adim <= n); });
      }
      // Öneriler: sepette olmayan ek ürünler
      var sepettekiler = c.items.map(function(it){ return it.handle; });
      var gorunen = 0;
      $$('[data-cek-o]', cek).forEach(function(o){ var var_ = sepettekiler.indexOf(o.dataset.cekO) > -1; o.hidden = var_; if (!var_) gorunen++; });
      $('[data-cek-oneri]', cek).hidden = gorunen === 0 || c.item_count === 0;
    };
    var yenile = function(){ return api(TH.root.replace(/\/?$/, '/') + 'cart.js').then(ciz).catch(function(){}); };
    var degis = function(sat, adet){ cek.classList.add('yukleniyor'); return api(TH.root.replace(/\/?$/, '/') + 'cart/change.js', {line: sat, quantity: adet}).then(ciz).finally(function(){ cek.classList.remove('yukleniyor'); }); };
    var ekle = function(id, adet){ cek.classList.add('yukleniyor'); return api(TH.cartAdd, {items:[{id:+id, quantity: adet||1}]}).then(yenile).finally(function(){ cek.classList.remove('yukleniyor'); }); };
    cek.addEventListener('click', function(e){
      if (e.target.closest('[data-cek-kapat]')) { if (e.target.closest('a')) { kapat(); return; } e.preventDefault(); kapat(); return; }
      var k = e.target.closest('.cek__k');
      if (k) {
        var sat = +k.dataset.sat, adet = +k.querySelector('.cek__adet span').textContent;
        if (e.target.closest('[data-cek-az]')) degis(sat, adet - 1);
        else if (e.target.closest('[data-cek-cok]')) degis(sat, adet + 1);
        else if (e.target.closest('[data-cek-sil]')) degis(sat, 0);
        return;
      }
      var eb = e.target.closest('[data-cek-ekle]'); if (eb) { ekle(eb.dataset.cekEkle, 1); return; }
      if (e.target.closest('[data-cek-bir-daha]') && sonVaryant) ekle(sonVaryant, 1);
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !cek.hidden) kapat(); });
    $$('.sepet-ik').forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); ac(); }); });
    TH.cekmece = {ac: ac, kapat: kapat, yenile: yenile};
  }

  // ---- Yapışkan satın alma çubuğu: seçili toplamı ve rengi göster ----
  var bar = $('[data-altbar]');
  if (bar) {
    var barBtn = $('[data-altbar-ekle]', bar), anaForm = $('form[data-urun-form]');
    if (barBtn && anaForm) barBtn.addEventListener('click', function(e){ e.preventDefault(); if (anaForm.requestSubmit) anaForm.requestSubmit(); else anaForm.querySelector('[type=submit]').click(); });
  }

  // ---- Yorum fotoğrafları: lightbox ----
  var lb;
  document.addEventListener('click', function(e){
    var a = e.target.closest('.ty__foto a, .ty-duvar a'); if (!a) return;
    e.preventDefault();
    if (!lb) { lb = document.createElement('div'); lb.className = 'lb'; lb.innerHTML = '<button type="button" aria-label="×">&times;</button><img alt="">'; document.body.appendChild(lb); lb.addEventListener('click', function(){ lb.classList.remove('acik'); }); }
    lb.querySelector('img').src = a.href; lb.classList.add('acik');
  });

  // ---- Kayan bant: içerik yetmezse çoğalt ----
  $$('[data-kayan]').forEach(function(k){ var ic = k.querySelector('.kayan__ic'); if (!ic) return; var h = ic.innerHTML; ic.innerHTML = h + h + h + h; });
})();
// Mobil dil menüsü: dışarı tıklayınca kapan
document.addEventListener('click', function(e){ var d = document.querySelector('[data-dil-m][open]'); if (d && !d.contains(e.target)) d.removeAttribute('open'); });

/* Site içi indirim teklifi: süre dolunca veya başka sekmeden dönünce */
(function(){
  var kok = document.querySelector('[data-teklif]'); if (!kok || document.querySelector('[data-tesekkur]')) return;
  var kod = kok.getAttribute('data-kod'), dk = parseFloat(kok.getAttribute('data-dk')) || 5, sekmeAktif = kok.getAttribute('data-sekme') === 'true';
  var pill = document.querySelector('[data-tk-pill]'), pillYazi = document.querySelector('[data-tk-pill-yazi]');
  function oku(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function yaz(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
  var BAS = 'velia_tk_bas', GOR = 'velia_tk_gor', OK = 'velia_tk_ok';
  if (!oku(BAS)) yaz(BAS, String(Date.now()));
  function uygulandiMi(){ return oku(OK) === kod; }
  function pillGoster(){ if (!pill) return; pill.hidden = false; if (uygulandiMi()) { pill.classList.add('tk--ok'); pillYazi.textContent = pillYazi.getAttribute('data-ok'); } }
  function easysellAcik(){ var m = document.querySelector('#easysell-modal, .es-modal'); if (!m) return false; var s = getComputedStyle(m); return s.display !== 'none' && s.visibility !== 'hidden' && m.offsetHeight > 0; }
  function ac(){
    if (uygulandiMi() || !kok.hidden) return;
    if (easysellAcik()) { setTimeout(ac, 4000); return; }
    kok.hidden = false; yaz(GOR, '1'); if (pill) pill.hidden = true;
  }
  function kapat(){ kok.hidden = true; pillGoster(); }
  var esDenendi = false;
  function esKodu(){
    var inp = document.getElementById('es-discount'); if (!inp) return;
    var alan = inp.closest('.row') ? inp.closest('.row').parentElement : null;
    if (alan && alan.textContent.indexOf(kod) > -1) return; // EasySell sepetteki kodu zaten uygulamış
    if (esDenendi && inp.value === kod) return;
    esDenendi = true;
    if (inp.value !== kod) { inp.value = kod; inp.dispatchEvent(new Event('input', {bubbles:true})); inp.dispatchEvent(new Event('change', {bubbles:true})); }
    var b = document.getElementById('es-discount-button'); if (b) setTimeout(function(){ b.click(); }, 300);
  }
  function uygula(){
    yaz(OK, kod);
    fetch('/discount/' + encodeURIComponent(kod), {credentials:'same-origin'}).catch(function(){});
    fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({discount: kod})})
      .then(function(){ if (window.TH && TH.cekmece && TH.cekmece.yenile) TH.cekmece.yenile(); document.dispatchEvent(new CustomEvent('velia:teklif', {detail:{kod:kod}})); })
      .catch(function(){});
    kapat();
  }
  kok.addEventListener('click', function(e){ if (e.target.closest('[data-tk-uygula]')) uygula(); else if (e.target.closest('[data-tk-kapat]')) kapat(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !kok.hidden) kapat(); });
  if (pill) pill.addEventListener('click', function(){ if (uygulandiMi()) return; kok.hidden = false; pill.hidden = true; });
  if (uygulandiMi()) { pillGoster(); } else if (oku(GOR)) { pillGoster(); }
  // EasySell formu açıldığında kodu otomatik doldur
  new MutationObserver(function(){ if (!uygulandiMi()) return; if (easysellAcik()) esKodu(); else esDenendi = false; }).observe(document.body, {subtree:true, attributes:true, attributeFilter:['style','class']});
  if (uygulandiMi() || oku(GOR)) return;
  var sure = dk * 60000, gecen = Date.now() - parseInt(oku(BAS) || Date.now(), 10);
  setTimeout(ac, Math.max(1000, sure - gecen));
  if (sekmeAktif) {
    var eskiBaslik = document.title, yeniBaslik = kok.getAttribute('data-baslik-sekme'), ayrildi = false;
    document.addEventListener('visibilitychange', function(){
      if (uygulandiMi() || oku(GOR) && kok.hidden && ayrildi === 'bitti') return;
      if (document.hidden) { ayrildi = true; if (!uygulandiMi()) document.title = yeniBaslik; }
      else { document.title = eskiBaslik; if (ayrildi === true && !uygulandiMi()) { ayrildi = 'bitti'; ac(); } }
    });
  }
})();

/* Son kullanılan dili hatırla (teşekkür sayfası yönlendirmesi için) */
(function(){ try { localStorage.setItem('velia_dil', document.documentElement.lang || 'en'); } catch(e){} })();

/* EasySell buton metnini sitenin diline çevir (EasySell tek dil destekliyor) */
(function(){
  var metin = window.TH && TH.t && TH.t.cod; if (!metin) return;
  function cevir(){
    var el = document.querySelectorAll('.es-popup-button .es-button-title, #es-sticky .es-button-content span:not(.es-loading-mask)');
    for (var i = 0; i < el.length; i++) { if (el[i].children.length === 0 && el[i].textContent.trim() && el[i].textContent !== metin) el[i].textContent = metin; }
  }
  var bekle = null;
  new MutationObserver(function(){ if (bekle) return; bekle = setTimeout(function(){ bekle = null; cevir(); }, 150); }).observe(document.body, {childList:true, subtree:true});
  cevir();
})();

/* EasySell sipariş sonrası: Shopify'ın kendi sipariş sayfasına müşterinin dilinde git.
   (EasySell siparişlerinde dil boş kaldığı için Shopify varsayılan olarak ana dile (EN) yönlendiriyor.) */
window.es_hook_before_redirect = function(order){
  try {
    try { localStorage.setItem('velia_tk_gor', '1'); } catch(e){}
    var u = order && order.order_status_url;
    var m = u && u.match(/\/(\d+)\/orders\/([a-z0-9]+)\/authenticate\?key=([a-z0-9]+)/i);
    if (!m) return;
    var dil = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'tr';
    window.location.replace('https://shopify.com/' + m[1] + '/account/orders/' + m[2] + '/authenticate?key=' + m[3] + '&locale=' + encodeURIComponent(dil));
    return new Promise(function(){}); // EasySell'in kendi yönlendirmesini beklet
  } catch(e) {}
};
